








import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';

// TODO: fix
/* tslint:disable:no-empty */

const namespace = 'userState';
@Component({
    components: {BButton},
})

export default class InfoModal extends Vue {
    constructor() {
        super();
    }
    @Emit()
    public close() {
    }
}
